<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-flex md12>
            <material-card
                color="green"
                title="Callback Request Summary"
                class="grid-card"
            >
                <v-layout row class="mt-0 ml-0">
                    <v-menu
                        class="mt-0"
                        v-model="datePickerMenu"
                        :close-on-content-click="true"
                        offset-y
                        full-width
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                style="max-width: 120px;"
                                hide-details
                                class="mr-3"
                                v-model="fromDate"
                                :value="fromDate"
                                label="From Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="fromDate"
                            @change="loadData"
                        ></v-date-picker>
                    </v-menu>
                </v-layout>
                <vue-good-table
                    class="pt-3"
                    ref="table"
                    :columns="columns"
                    :rows="callbackSummary"
                    :search-options="{
                        enabled: false,
                    }"
                >
                    <template slot="table-header-row" slot-scope="props">
                        <div>
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <div
                            @click="navigateToList(props.row)"
                            v-bind:class="{
                                'font-weight-medium': isTotal(props.row),
                            }"
                        >
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                </vue-good-table>
            </material-card>
        </v-flex>
    </v-container>
</template>

<script>
import moment from "moment";
import { toISOLocal, sum } from "../../utils/helpers.js";

export default {
    data: () => ({
        callbackSummary: [],
        datePickerMenu: false,
        fromDate: toISOLocal(
            new Date(
                moment()
                    .subtract(1, "month")
                    .add(1, "day")
            )
        ).substr(0, 10),

        columns: [
            {
                sortable: false,
                label: "User",
                field: "assignedTo",
                hidden: false,
            },
            {
                sortable: true,
                label: "Pending",
                field: "pending",
                type: "number",
                hidden: false,
            },
            {
                sortable: true,
                label: "Completed",
                field: "completed",
                type: "number",
                hidden: false,
            },
            {
                sortable: true,
                label: "Total",
                field: "total",
                type: "number",
                hidden: false,
            },
        ],
    }),
    async created() {
        this.loadData();
    },
    methods: {
        async loadData() {
            const callbackSummary = await this.$http.get(
                "api/communications/GetCallbackRequestSummary?fromDate=" +
                    this.fromDate
            );

            callbackSummary.push({
                assignedTo: "Grand Total",
                pending: sum(callbackSummary.map((c) => +c.pending)),
                completed: sum(callbackSummary.map((c) => +c.completed)),
                total: sum(callbackSummary.map((c) => +c.total)),
            });

            this.callbackSummary = callbackSummary;
        },
        isTotal(row) {
            return row.assignedTo == "Grand Total";
        },
        navigateToList(row) {},
    },
};
</script>
<style></style>
